import React from "react";
import { Provider, ErrorBoundary as RollbarErrorBoundary } from "@rollbar/react";
import PropTypes from "prop-types";

export const FallbackComponent = () => (
  <div className="error_boundary_root">
    <h2>Something went wrong.</h2>
    <span>
      The team has been notified and we are working on a fix right away. Thank you for your
      patience.
    </span>
  </div>
);

const ErrorBoundary = ({ rollbar: accessToken, env: environment, moduleName, children }) => (
  <Provider
    config={{
      accessToken,
      environment,
      payload: {
        context: moduleName
      },
      enabled: environment !== "development",
      captureUncaught: false,
      captureUnhandledRejections: false,
      ignoredMessages: ["Cannot read property of undefined/null expression"]
    }}
  >
    <RollbarErrorBoundary level="error" fallbackUI={FallbackComponent}>
      {children}
    </RollbarErrorBoundary>
  </Provider>
);

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  moduleName: PropTypes.string,
  rollbar: PropTypes.string,
  env: PropTypes.string
};

export default ErrorBoundary;
